// extracted by mini-css-extract-plugin
module.exports = {"error_icon":"tire-size-calculator_error_icon__SX20f","boxed_tier_selector_container":"tire-size-calculator_boxed_tier_selector_container__cYvX6"};